<p-button
  [rounded]="rounded()"
  [size]="size()"
  [severity]="severity()"
  [disabled]="disable()"
  [variant]="variant()"
  (onClick)="onClick($event)"
  [icon]="icon() ? 'pi pi-' + icon() : undefined"
  [iconPos]="iconPos()"
  [label]="label()"
  [styleClass]="buttonClass()"
/>
